/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VcdsServiceTypeEnum = 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR';

export const VcdsServiceTypeEnum = {

    VCDS: 'VCDS' as VcdsServiceTypeEnum,

    VCDR: 'VCDR' as VcdsServiceTypeEnum,

    VMCFS: 'VMCFS' as VcdsServiceTypeEnum,

    SRM: 'SRM' as VcdsServiceTypeEnum,

    VSR: 'VSR' as VcdsServiceTypeEnum
};

